module.exports = {"sld:ColorMapEntry":[{"color":"#0074ad","label":"< 0.0","quantity":0},{"color":"#9dc4b5","label":" 0.0- 0.07741","quantity":0.00077},{"color":"#e6efc3","label":" 0.07741- 0.34736","quantity":0.00347},{"color":"#ffe89e","label":" 0.34736- 0.89034","quantity":0.0089},{"color":"#f5af7f","label":" 0.89034- 1.93146","quantity":0.01931},{"color":"#ed6d32","label":" 1.93146- 14.68883","quantity":0.14689}]}


//////////////////
// WEBPACK FOOTER
// ./static/bunSld_cropRisks/cfxssl_raster/rice_MME_1981_2016_lcr_80.json
// module id = OPqs
// module chunks = 171